export const charges: {[key: string]: number,} = {
  BK_TO_BK: 0,
  BK_TO_OTHERS: 1000,
  BK_TO_MTN_WALLET: 0,
  BK_TO_AIRTEL_WALLET: 0,
  default: 0,
}


export const getApiBaseUrl = (): string => {
  return (window as any).APP_CONFIG?.API_BASE_URL || process.env.REACT_APP_D_CORE_URL || ''
}

export const getPublicUrl = (): string => {
  return (window as any).APP_CONFIG?.PUBLIC_URL || process.env.PUBLIC_URL || ''
}
